import { render, staticRenderFns } from "./SalesNumberDisplayer.vue?vue&type=template&id=35b23bb6"
import script from "./SalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports